// istanbul ignore file
export { Icon, type IconProps } from "./Icon";
